export default __webpack_public_path__ + "static/Cabin-Italic-e7af8d32eddd53128282308c508bd4a6.ttf";